import React from "react";
import style from "./Image.module.css";
import { Link } from "react-router-dom";
import { RouteNames } from "../../router";
import { LoadableImage } from "../LoadableImage";

export const Image = ({ img, alt, text, title, id, width, height }) => {
  return (
    <div className={style.projectContainer}>
      <Link to={`${RouteNames.PORTFOLIO}/${id}`}>
        <LoadableImage
          className={style.projectImage}
          src={img}
          alt={alt}
          width={width || 928}
          height={height || 569}
        />
        <div className={style.projectHovering}>
          <p className={style.projectTitle}>{title}</p>
          <p className={style.projectText}>{text}</p>
        </div>
      </Link>
    </div>
  );
};
